import React from 'react';

/*
 * 26-week bar sparkline shared by the engagement tabs. A week with no data (before the usage history
 * starts) is a pale dash, a zero week a thin grey bar, a count a blue bar scaled to the row's maximum.
 */
const HEIGHT = 30;
const BAR = 4;
const GAP = 1.6;

const COLORS = { none: '#E3E6EA', zero: '#B8BEC6', count: '#0095DA' };

export default function Sparkline({ values, label, weeks }) {
  const max = Math.max(1, ...values.map(v => v || 0));
  return (
    <div
      role='img'
      aria-label={label}
      style={{
        display: 'flex', alignItems: 'flex-end', height: HEIGHT, width: values.length * (BAR + GAP) - GAP,
      }}
    >
      {values.map((value, index) => {
        let kind = 'count';
        if (value === null || value === undefined) {
          kind = 'none';
        } else if (value === 0) {
          kind = 'zero';
        }
        const height = kind === 'count' ? Math.max(3, Math.round((value / max) * HEIGHT)) : 2;
        return (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            data-bar={kind}
            title={(weeks ? weeks[index] + ': ' : '') + (kind === 'none' ? '–' : value)}
            style={{
              display: 'block',
              flex: '0 0 auto',
              width: BAR,
              height,
              marginRight: index === values.length - 1 ? 0 : GAP,
              background: COLORS[kind],
            }}
          />
        );
      })}
    </div>
  );
}
